/** Людина у вузлі дерева — керівник чи співробітник (скорочене представлення). */
export interface DepartmentTreePerson {
    uuid: string
    fullName: string | null
    photoUrl: string | null
}

/** Права на конкретний підрозділ — рахує бек, фронт лише показує/ховає дії. */
export interface DepartmentPermissions {
    create?: boolean
    read_collection?: boolean
    read?: boolean
    update?: boolean
    delete?: boolean
}

/**
 * Вузол структури, як його віддає `GET /services/departments/tree`:
 * плоский список із посиланням на батька — дерево збирає фронт.
 */
export interface DepartmentTreeItem {
    uuid: string
    title: string
    isMain: boolean
    sorting: number
    parentUuid: string | null
    /** Один обов'язковий керівник (`SPEC-006` §3.1). */
    chief: DepartmentTreePerson | null
    /** Лише активні співробітники відділу. */
    users: DepartmentTreePerson[]
    _permissions?: DepartmentPermissions
}

/** Той самий вузол у формі, яку розуміє Ship-дерево (`id`/`parentId`). */
export interface DepartmentTreeNode extends DepartmentTreeItem {
    id: string
    parentId: string | null
}

/**
 * Опис у підтвердженні видалення — наслідок для людей (`SPEC-006` Р-10, §7.5).
 * Один текст і в дереві, і в меню рядка таблиці.
 */
export const DEPARTMENT_DELETE_CONFIRM_TEXT = 'Співробітники цього відділу перейдуть до вищого відділу.'

/** Людина в картці відділу (`user:short:read`). */
export interface DepartmentCardPerson {
    '@id'?: string
    uuid?: string
    fullName?: string | null
    shortName?: string | null
    position?: string | null
    status?: string | null
}

/** Значення картки відділу, які читає шаблон (`department:read`). */
export interface DepartmentCardValues {
    uuid?: string
    title?: string
    isMain?: boolean
    parent?: { uuid?: string; title?: string } | null
    chief?: DepartmentCardPerson | null
    users?: DepartmentCardPerson[]
    _permissions?: DepartmentPermissions
}
